import m from "../../geodata/es2015/southAfricaLow";
window.am4geodata_southAfricaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/southAfricaLow.js
// module id = null
// module chunks = 